import React from "react";
import { FaChartBar, FaBolt } from "react-icons/fa";
import { MdAnalytics } from "react-icons/md";


export default function Hero() {
    return (
        <section className="hero" style={{ backgroundImage: 'url("/images/stadium-bg.jpg")' }}>
            <div className="hero-content">
                <span className="hero-badge">AI-Powered Football Analytics</span>

                <h1>
                    Football Match <br /><span className="highlight">Prediction Engine</span>
                </h1>

                <p>
                    Advanced machine learning models analyze historical data, team
                    performance, and real-time statistics to predict match outcomes with
                    unprecedented accuracy.
                </p>

                <div className="hero-stats">
                    <span>
                        <MdAnalytics size={18} /> 10M+ Match Records
                    </span>
                    <span>
                        <FaChartBar size={18} /> 73.2% Accuracy
                    </span>
                    <span>
                        <FaBolt size={18} /> Real-time Analysis
                    </span>
                </div>
            </div>
        </section>
    );
}
